import React, { useEffect, useState } from "react";
import Facebook from "../assets/images/facebook.svg";
import Twitter from "../assets/images/twitter.svg";
import Linkedin from "../assets/images/linkedin.svg";
import Instagram from "../assets/images/instagram.svg";
import Youtube from "../assets/images/youtube.svg";
import { Link } from "react-router-dom";

function Footer() {
  const [footerContent, setFooterContent] = useState(null);
  const [customPageOne, setCustomPageOne] = useState(null);
  const [customPageSecond, setCustomPageSecond] = useState(null);

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  useEffect(() => {
    const checkLocalStorage = setInterval(() => {
      let localFooterContent = localStorage.getItem("footerSection");
      let localCustomPageOne = localStorage.getItem("customPage1");
      let localCustomPageSecond = localStorage.getItem("customPage2");

      if (localFooterContent) {
        setFooterContent(JSON.parse(localFooterContent));
        setCustomPageOne(JSON.parse(localCustomPageOne));
        setCustomPageSecond(JSON.parse(localCustomPageSecond));
        clearInterval(checkLocalStorage);
      }
    }, 1000); // Check every second

    return () => clearInterval(checkLocalStorage); // Cleanup on unmount
  }, []);

  return (
    <footer>
      <div className="footer-main">
        <div className="footer-box">
          <Link to="/" className="footer-logo">
            {footerContent?.bottom_logo && (
              <img
                src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${footerContent.bottom_logo}`}
                alt={footerContent.company_name}
              />
            )}
          </Link>
          <p>{footerContent?.footer_address}</p>
          <p>
            <a href={`tel:${footerContent?.office_phone_no}`}>
              {footerContent?.office_phone_no}
            </a>
          </p>
          <p>
            <a href={`mailto:${footerContent?.info_email}`}>
              {footerContent?.info_email}
            </a>
          </p>
        </div>
        <div className="footer-box">
          <h3>Company</h3>
          <ul>
            <li>
              <Link to="/about-us" title="About Us">
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/page/quality-transparency"
                title="Quality Transparency"
              >
                Quality Transparency
              </Link>
            </li>
            <li>
              <Link to="/careers" title="Careers">
                Careers
              </Link>
            </li>

            {customPageOne && (
              <li>
                <Link
                  to={"/page/" + customPageOne?.code}
                  title={customPageOne?.page_name}
                >
                  {customPageOne?.page_name}
                </Link>
              </li>
            )}

            {customPageSecond && (
              <li>
                <Link
                  to={"/page/" + customPageSecond?.code}
                  title={customPageSecond?.page_name}
                >
                  {customPageSecond?.page_name}
                </Link>
              </li>
            )}
          </ul>
        </div>
        <div className="footer-box">
          <h3>Customer Support</h3>
          <ul>
            <li>
              <Link to="/contact-us" title="Contact Us">
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/page/support-center" title="Support Center">
                Support Center
              </Link>
            </li>
            <li>
              <Link to="/page/shipping" title="Shipping">
                Shipping
              </Link>
            </li>
            <li>
              <Link to="/page/returns" title="Returns">
                Returns
              </Link>
            </li>
            <li>
              <Link to="/faqs" title="FAQ's">
                FAQ's
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-box">
          <h3>Customer Service</h3>
          <ul>
            <li>
              <Link to="/page/track-my-order" title=">Track My Order">
                Track My Order
              </Link>
            </li>
            <li>
              <Link to="/page/return-policy" title="Return Policy">
                Return Policy
              </Link>
            </li>
            <li>
              <Link
                to="/page/international-shipping"
                title="International Shipping"
              >
                International Shipping
              </Link>
            </li>

            <li>
              <Link to="/page/subscription" title="Subscription">
                Subscription
              </Link>
            </li>

            <li>
              <Link to="/page/products-recalls" title="Products Recalls">
                Products Recalls
              </Link>
            </li>

            {/* <li>
              <Link to="/page/terms-conditions" title="Terms & Conditions">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/page/privacy-policy" title="Privacy Policy">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/page/legal" title="Legal">
                Legal
              </Link>
            </li> */}
          </ul>
        </div>
        <div className="footer-box">
          <h3>My Account</h3>
          <ul>
            {!token && (
              <li>
                <Link to="/sign-in" title="Account Login">
                  Account Login
                </Link>
              </li>
            )}
            <li>
              <Link to="/profile/my-orders" title="Order History">
                Order History
              </Link>
            </li>
            <li>
              <Link to="/profile/wishlist" title="Wishlist">
                Wishlist
              </Link>
            </li>
            <li>
              <Link to="/profile/return-orders" title="Return’s Order">
                Return’s Order
              </Link>
            </li>
            {!token ? (
              <li>
                <Link to="/profile/my-subscription" title="My Subscription">
                  My Subscription
                </Link>
              </li>
            ) : (
              <li>
                <Link to="/profile/my-subscription" title="My Subscription">
                  My Subscription
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        {/* Left */}
        <div
          className="footer-copy"
          dangerouslySetInnerHTML={{
            __html: footerContent?.footer_copyright_text,
          }}
        ></div>

        {/* Center – Terms */}
        <div className="footer-links">
          <Link to="/page/terms-conditions">Terms & Conditions</Link>
          <span>|</span>
          <Link to="/page/privacy-policy">Privacy Policy</Link>
          <span>|</span>
          <Link to="/page/legal">Legal</Link>
          <span>|</span>
          <Link to="/page/return-policy">Return Policy</Link>
        </div>

        {/* Right – Social Icons */}
        <ul className="footer-social">
          {footerContent?.facebook_url && (
            <li>
              <a href={footerContent.facebook_url} target="_blank" rel="noopener noreferrer">
                <img src={Facebook} alt="Facebook" />
              </a>
            </li>
          )}

          {footerContent?.twitter_url && (
            <li>
              <a href={footerContent.twitter_url} target="_blank" rel="noopener noreferrer">
                <img src={Twitter} alt="Twitter" />
              </a>
            </li>
          )}

          {footerContent?.linkedin_url && (
            <li>
              <a href={footerContent.linkedin_url} target="_blank" rel="noopener noreferrer">
                <img src={Linkedin} alt="LinkedIn" />
              </a>
            </li>
          )}

          {footerContent?.instagram_url && (
            <li>
              <a href={footerContent.instagram_url} target="_blank" rel="noopener noreferrer">
                <img src={Instagram} alt="Instagram" />
              </a>
            </li>
          )}

          {footerContent?.youtube_url && (
            <li>
              <a href={footerContent.youtube_url} target="_blank" rel="noopener noreferrer">
                <img src={Youtube} alt="YouTube" />
              </a>
            </li>
          )}
        </ul>

      </div>

    </footer>
  );
}

export default Footer;
